import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const MoroccoFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15449'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15449)'>
				<rect
					width='20'
					height='14'
					fill='#E33B44'
				/>
				<path
					d='M10.3824 8.09154L10.0006 7.82481L9.61876 8.09154L8.7216 8.71831L9.04562 7.71022L9.19344 7.25032L8.80245 6.96663L7.95394 6.35096L9.024 6.34152L9.49624 6.33735L9.64896 5.89046L10.0006 4.86162L10.3522 5.89046L10.5049 6.33735L10.9771 6.34152L12.0472 6.35096L11.1987 6.96663L10.8077 7.25032L10.9555 7.71022L11.2795 8.71831L10.3824 8.09154Z'
					stroke='#0A6135'
					strokeWidth='1.33333'
				/>
			</g>
		</svg>
	);
};

export default MoroccoFlagIcon;
